// src/plugins/axios.js
import axios from 'axios'

// Crear una instancia de axios
const api = axios.create({
  //baseURL: 'http://127.0.0.1:8000', // URL base para todas las peticiones
  baseURL: 'https://qa-api.goaligner.co', // URL base para todas las peticiones
  //baseURL: 'https://api.goaligner.co', // URL base para todas las peticiones
})

// Interceptor para agregar el token de autorización si existe
api.interceptors.request.use(
  config => {
    // const token = localStorage.getItem('token') // O donde guardes el token
    const token = `Bearer ${localStorage.getItem('token')}` // O donde guardes el token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

export default api
